<div class="Dialog" mat-dialog-content>
  <div>
    <p>Failed to get customer info. Please close this tab and try again. If this problem persists, please contact customer service.</p>
  </div>
  <div class="Flexbox Align--center Buttons Gap--smaller">
  </div>
</div>